// extracted by mini-css-extract-plugin
export default {"navbar":"navbar_navbar__v0uz+","mobile":"navbar_mobile__76uuX","desktop":"navbar_desktop__v4arb","hamburgerIcon":"navbar_hamburgerIcon__n5RUO"};